import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import icSettings from '@iconify/icons-ic/twotone-settings';

@Component({
  selector: 'codemiro-config-panel-toggle',
  templateUrl: './config-panel-toggle.component.html',
  styleUrls: ['./config-panel-toggle.component.scss']
})
export class ConfigPanelToggleComponent implements OnInit {

  @Output() openConfig = new EventEmitter();

  icSettings = icSettings;

  constructor() { }

  ngOnInit() {
  }


  // contact support 
  contactSupport() {
    window.open('https://wa.me/919818879566?text=Hello%20%I%20need%20help%20regarding%20my%20HOA%20account', '_blank');
  }

}
